import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from 'app/providers/api.service';
import { DomSanitizer } from '@angular/platform-browser';
import * as _ from 'lodash';

import { MatTabsModule } from '@angular/material/tabs';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list'

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';


@Component({
  selector: 'app-help-vedios',
  templateUrl: './help-vedios.component.html',
  styleUrls: ['./help-vedios.component.scss']
})
export class HelpVediosComponent implements OnInit {
  vdeosList;
  vdeosListCpy;
  loading = true;
  filterTerm;
  constructor(public apiSrvc: ApiService, private _sanitizer: DomSanitizer) { }

  ngOnInit() {
    // alert("777777777")
    this.vdeosDetails();
  }
  vdeosDetails() {
    // alert("1111111")

    let rte = `kb/shwVideos`
    this.apiSrvc.get(rte).subscribe((res) => {
      console.log(res['data']);
      for (let i = 0; i < res['data'].length; i++) {
        for (let j = 0; j < res['data'][i].videos.length; j++) {
          res['data'][i].videos[j]['safeURL'] = this._sanitizer.bypassSecurityTrustResourceUrl(res['data'][i].videos[j].vdo_embd_tx)
        }
      }

      this.vdeosList = res['data'];
      this.vdeosListCpy = _.cloneDeep(res['data']);
      console.log(this.vdeosList)
      if (res['status'] == 200) {
      }
    })
  }
  initlizeitems() {
    this.vdeosList = _.cloneDeep(this.vdeosListCpy);
  }
  searchName(event) {
    console.log("search")
    console.log(event)
    this.initlizeitems();
    if (event.target.value) {
      this.vdeosList = this.vdeosList.filter((k) => {
        return (k.vdeo_hdr_txt + "").toLowerCase().indexOf(event.target.value.toLowerCase()) > -1;
      })
    }
  }
}
